import mixin from '@/store/mixins/data-grid'

const { stateMixin, gettersMixin, mutationsMixin, actionsMixin } = mixin

const state = {
  ...stateMixin('order', 'created_at')
}

const getters = {
  ...gettersMixin()
}

const mutations = {
  ...mutationsMixin()
}

const actions = {
  ...actionsMixin({
    singleCallback: (order) => {
      return new Promise(async (resolve) => {
        await order.loadComments()
        await order.loadHoldReasons()
        resolve()
      })
    }
  })
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
